/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Form_Auth_BeforeInputs */

const es_cap_form_auth_before = /** @type {(inputs: Cap_Form_Auth_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirma tu titulación y envía la solicitud. Estás conectado como `)
};

const gl_cap_form_auth_before = /** @type {(inputs: Cap_Form_Auth_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirma a túa titulación e envía a solicitude. Estás conectado como `)
};

const en_cap_form_auth_before = /** @type {(inputs: Cap_Form_Auth_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm your licence and submit your request. You are signed in as `)
};

/**
* | output |
* | --- |
* | "Confirm your licence and submit your request. You are signed in as" |
*
* @param {Cap_Form_Auth_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_form_auth_before = /** @type {((inputs?: Cap_Form_Auth_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Form_Auth_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_form_auth_before(inputs)
	if (locale === "en") return en_cap_form_auth_before(inputs)
	return es_cap_form_auth_before(inputs)
});